import { makeAutoObservable } from "mobx";

import { RootStore } from "./RootStore";

class NavMenuStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  isNavMenuOpen = false;

  setIsNavMenuOpen = (value: boolean): void => {
    this.isNavMenuOpen = value;
  };

  toggleNavMenu = (): void => {
    this.isNavMenuOpen = !this.isNavMenuOpen;
  };
}

export default NavMenuStore;
